import fb from "../firebase";
import firebase from "firebase/compat/app";
import {VeterinarioObject} from "../../models/Veterinario";
import {useFirestore, UseFirestoreOptions, useFirestoreSnap} from "./useFirestore";


export const useGetVeterinarios = (args: {userId: string}, options?: UseFirestoreOptions): [VeterinarioObject[], boolean] => {
  const {userId} = args;

  return useFirestore<VeterinarioObject>({
    queryKey: `useGetVeterinarios:${userId}`,
    query: () => fb.db.collection('veterinarios')
      .where('owner', '==', userId)
      .orderBy('nome', 'asc'),
    options,
  });
}

export const useVeterinariosSnap = (args: {userId: string}, options?: UseFirestoreOptions): [firebase.firestore.QuerySnapshot | undefined, boolean] => {
  const {userId} = args;

  return useFirestoreSnap({
    queryKey: `useVeterinariosSnap:${userId}`,
    query: () => fb.db.collection('veterinarios')
      .where('owner', '==', userId)
      .orderBy('nome', 'asc'),
    options,
  });
}
